import { t as tr } from '@hana/i18n';
import './CostQuality.i18n';
import { IconCamera } from '@tabler/icons-react';
import s from './extra.module.css';

// Mint-Cost › tab Chất lượng chứng từ: 4 thẻ số + theo người nhập + bị chặn / trả về. Số liệu mẫu của board.

const KPI = [
  { k: 'Ảnh đạt lần đầu', v: '86', u: '%', tone: '' },
  { k: 'Bị trả về', v: '17', u: 'chứng từ', tone: 'warn' },
  { k: 'Nhập trễ hạn', v: '6', u: 'khoản', tone: 'err' },
  { k: 'Đang chặn tạm ứng', v: '1', u: 'người', tone: 'err' },
] as const;

/** [người, ghế, ảnh nộp, % đạt, trả về, trễ, chặn tạm ứng] */
const PEOPLE = [
  ['ANH', 'OPS-FLD', 46, 91, 2, 0, false],
  ['KIỆT', 'OPS-FLD', 38, 74, 7, 3, true],
  ['AN', 'OPS-FLD', 29, 86, 3, 1, false],
  ['THANH', 'TRD-DSP', 22, 95, 1, 0, false],
  ['CÔNG', 'TRD-DRV', 31, 81, 4, 2, false],
  ['MAI', 'CSD-CSO', 14, 100, 0, 0, false],
] as const;

const RETURNED = [
  ['Biên nhận nâng hạ · SE260633750', 'KIỆT', '22/Oct/2026 09:40', 'Ảnh mờ'],
  ['Phiếu cân · TRF2610079', 'CÔNG', '22/Oct/2026 07:15', 'Thiếu góc'],
  ['Lệ phí HQ · SL260623140', 'AN', '21/Oct/2026 16:02', 'Sai job'],
  ['Biên nhận phí bãi · SE260634330', 'KIỆT', '21/Oct/2026 11:30', 'Lóa sáng'],
  ['Hoá đơn dầu · TRF2610074', 'THẢO', '20/Oct/2026 19:48', 'Nhập trễ'],
] as const;

const tone = (ok: number) => (ok >= 90 ? 'var(--ok)' : ok >= 80 ? 'var(--warn)' : 'var(--err)');

export function CostQuality() {
  return (
    <>
      <div className={s.kpis}>
        {KPI.map((k) => (
          <section key={k.k} className={s.kpi}>
            <div>{k.k}</div>
            <b style={{ color: k.tone ? `var(--${k.tone})` : 'var(--tx)' }}>{k.v}</b>
            <span>{k.u}</span>
          </section>
        ))}
      </div>
      <div className={s.two}>
        <section className={s.panel} aria-label="Theo người nhập">
          <h2>{tr('cq.1')}</h2>
          <div className={s.pHead}>
            <span>{tr('cq.2')}</span>
            <span style={{ textAlign: "right" }}>{tr('cq.3')}</span>
            <span className={s.pl}>{tr('cq.4')}</span>
            <span style={{ textAlign: 'right' }}>{tr('cq.5')}</span>
            <span style={{ textAlign: 'right' }}>{tr('cq.6')}</span>
            <span className={s.pl}>{tr('cq.7')}</span>
          </div>
          {PEOPLE.map(([who, seat, n, ok, ret, late, block]) => (
            <div key={who} className={s.pRow}>
              <span>
                <b style={{ fontWeight: 'var(--fw-label)' }}>{who}</b> <span className={s.sm}>{seat}</span>
              </span>
              <span style={{ textAlign: 'right' }}>{n}</span>
              <span className={`${s.okCell} ${s.pl}`}>
                <span className={s.track}>
                  <i style={{ width: `${ok}%`, background: tone(ok) }} />
                </span>
                {ok}%
              </span>
              <span style={{ textAlign: 'right' }}>{ret}</span>
              <span style={{ textAlign: 'right', color: late ? 'var(--err)' : undefined }}>{late}</span>
              <span className={s.pl}>{block && <span className={`${s.why} ${s.w_err}`}>{tr('cq.8')}</span>}</span>
            </div>
          ))}
        </section>
        <section className={s.panel} aria-label="Chứng từ bị trả về">
          <h2>{tr('cq.9')}</h2>
          {RETURNED.map(([k, who, when, why]) => (
            <div key={k} className={s.ret}>
              <span className={s.thumb} aria-hidden="true">
                <IconCamera size={18} />
              </span>
              <div className={s.retTx}>
                <b>{k}</b>
                <div className={s.sm}>
                  {who} · {when}
                </div>
              </div>
              <span className={`${s.why} ${why === 'Nhập trễ' || why === 'Sai job' ? s.w_warn : s.w_err}`}>{why}</span>
            </div>
          ))}
          <div className={s.note}>{tr('cq.10')}</div>
        </section>
      </div>
    </>
  );
}
